import { Action } from '@ngrx/store';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { LoadSummaryRequest, LoadSummaryResponse, DownloadSummarySearchRequest, PagingSorting } from '../../models';

export enum ContractActionTypes {
  ExecuteSearch = '[Contract] Execute Search',

  ProcessQueryString = '[Contract] Process Query String',

  NextPage = '[Contract] Next Page',
  PrevPage = '[Contract] Previous Page',
  SetPageSize = '[Contract] Set Page Size',
  LastPage = '[Contract] Last Page',
  FirstPage = '[Contract] First Page',
  SortBy = '[Contract] Sort By',

  LoadSummary = '[Contract] Summary',
  LoadSummarySuccess = '[Contract] Summary Success',
  LoadSummaryFailure = '[Contract] Summary Failure',

  DownloadRequestForm = '[Contract] Download Request Form',
  DownloadRequestFormSuccess = '[Contract] Download Request Form Success',
  DownloadRequestFormFailure = '[Contract] Download Request Form Failure',

  DownloadSummarySearch = '[Contract] Download Summary Search',
  DownloadSummarySearchSuccess = '[Contract] Download Summary Search Success',
  DownloadSummarySearchFailure = '[Contract] Download Summary Search Failure'
}

export class ProcessQueryString implements Action {
  readonly type = ContractActionTypes.ProcessQueryString;
  constructor(public payload: string) {}
}

export class NextPage implements Action {
  readonly type = ContractActionTypes.NextPage;
  constructor(public payload: LoadSummaryRequest, public pagingSorting: PagingSorting) {}
}

export class PrevPage implements Action {
  readonly type = ContractActionTypes.PrevPage;
  constructor(public payload: LoadSummaryRequest, public pagingSorting: PagingSorting) {}
}

export class SetPageSize implements Action {
  readonly type = ContractActionTypes.SetPageSize;
  constructor(public payload: number, public searchCriteria: LoadSummaryRequest) {}
}

export class LastPage implements Action {
  readonly type = ContractActionTypes.LastPage;
  constructor(public payload: LoadSummaryRequest, public pagingSorting: PagingSorting) {}
}

export class FirstPage implements Action {
  readonly type = ContractActionTypes.FirstPage;
  constructor(public payload: LoadSummaryRequest, public pagingSorting: PagingSorting) {}
}

export class SortBy implements Action {
  readonly type = ContractActionTypes.SortBy;
  constructor(public payload: string, public searchCriteria: LoadSummaryRequest, public pagingSorting: PagingSorting) {}
}

export class ExecuteContractSearch implements Action {
  readonly type = ContractActionTypes.ExecuteSearch;
  constructor(public payload: LoadSummaryRequest) {}
}

export class LoadSummary implements Action {
  readonly type = ContractActionTypes.LoadSummary;
  constructor(public payload: LoadSummaryRequest) {}
}

export class LoadSummarySuccess implements Action {
  readonly type = ContractActionTypes.LoadSummarySuccess;
  constructor(public payload: LoadSummaryResponse, public httpHeaders: HttpHeaders) {}
}

export class LoadSummaryFailure implements Action {
  readonly type = ContractActionTypes.LoadSummaryFailure;
  constructor(public payload: HttpErrorResponse | string) {}
}

export class DownloadRequestForm implements Action {
  readonly type = ContractActionTypes.DownloadRequestForm;
  constructor(public payload: { id: string }) {}
}

export class DownloadRequestFormSuccess implements Action {
  readonly type = ContractActionTypes.DownloadRequestFormSuccess;
  constructor(public payload: { id: string }) {}
}

export class DownloadRequestFormFailure implements Action {
  readonly type = ContractActionTypes.DownloadRequestFormFailure;
  constructor(public payload: { id: string; error: HttpErrorResponse | string }) {}
}

export class DownloadSummarySearch implements Action {
  readonly type = ContractActionTypes.DownloadSummarySearch;
  constructor(public payload: DownloadSummarySearchRequest) {}
}

export class DownloadSummarySearchSuccess implements Action {
  readonly type = ContractActionTypes.DownloadSummarySearchSuccess;
  constructor(public payload: DownloadSummarySearchRequest) {}
}

export class DownloadSummarySearchFailure implements Action {
  readonly type = ContractActionTypes.DownloadSummarySearchFailure;
  constructor(public payload: HttpErrorResponse | string) {}
}

export type ContractActions =
  | LoadSummary
  | LoadSummarySuccess
  | LoadSummaryFailure
  | DownloadSummarySearch
  | DownloadSummarySearchSuccess
  | DownloadSummarySearchFailure
  | DownloadRequestForm
  | DownloadRequestFormSuccess
  | DownloadRequestFormFailure
  | ExecuteContractSearch
  | ProcessQueryString
  | NextPage
  | PrevPage
  | SetPageSize
  | LastPage
  | FirstPage
  | SortBy;
